import { parseLocalDate } from '../../../../utils/formatLocalDate';

const DAY_NAMES = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

function sortKeyForWeekday(weekday) {
  if (weekday.day_number != null && !Number.isNaN(Number(weekday.day_number))) {
    const dn = Number(weekday.day_number);
    if (dn >= 0 && dn <= 6) return dn === 0 ? 7 : dn;
    if (dn >= 1 && dn <= 7) return dn;
  }
  const name = (weekday.name || '').toLowerCase();
  const idx = DAY_NAMES.indexOf(name);
  return idx === -1 ? 99 : idx === 0 ? 7 : idx;
}

/** Map a calendar date to the matching weekday record from reference data. */
function resolveWeekdayForDate(date, weekdays = []) {
  if (!date || !weekdays.length) return null;

  const jsDay = date.getDay();
  const isoDay = jsDay === 0 ? 7 : jsDay;
  const dayName = DAY_NAMES[jsDay];

  const byName = weekdays.find((w) => (w.name || '').toLowerCase() === dayName);
  if (byName) return byName;

  return (
    weekdays.find((w) => {
      const dn = Number(w.day_number);
      if (Number.isNaN(dn)) return false;
      return dn === jsDay || dn === isoDay || dn === jsDay + 1;
    }) || null
  );
}

/** Unique weekdays (Mon–Sun model) that occur at least once in [startDate, endDate]. */
export function getWeekdaysInDateRange(startDate, endDate, weekdays = []) {
  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);
  if (!start || !end || start > end || !weekdays.length) return [];

  const seen = new Set();
  const matched = [];
  const cursor = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endTime = end.getTime();

  while (cursor.getTime() <= endTime) {
    const weekday = resolveWeekdayForDate(cursor, weekdays);
    if (weekday && !seen.has(weekday.id)) {
      seen.add(weekday.id);
      matched.push(weekday);
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return matched.sort((a, b) => sortKeyForWeekday(a) - sortKeyForWeekday(b));
}

export function getWeekdayIdsInDateRange(startDate, endDate, weekdays = []) {
  return getWeekdaysInDateRange(startDate, endDate, weekdays).map((w) => w.id);
}
